<template>
  <v-container fluid>
    <v-breadcrumbs
      large
      class="pa-0"
      :items="breadcrumbsItems"
      v-if="isLokalita"
    >
      <template v-slot:divider>
        <v-icon>mdi-chevron-right</v-icon>
      </template>
    </v-breadcrumbs>
    <v-tabs v-model="tab">
      <v-tab>Hlavné údaje</v-tab>
      <v-tab>Mapa</v-tab>
      <v-tab>Zrážky - {{ zrazky.length }}</v-tab>
      <v-tab v-if="zrazky.length > 0">Grafy</v-tab>

      <v-tab-item>
        <v-container class="mt-2 elevation-3" fluid>
          <v-row dense>
            <v-col md="2" class="font-weight-black">ID:</v-col>
            <v-col>{{ stanica.ID }}</v-col>
          </v-row>
          <v-row dense>
            <v-col md="2" class="font-weight-black">Stanica:</v-col>
            <v-col>{{ stanica.Stanica }}</v-col>
          </v-row>
          <v-row dense>
            <v-col md="2" class="font-weight-black">Indikatív:</v-col>
            <v-col>{{ stanica.Indik }}</v-col>
          </v-row>
          <v-row dense>
            <v-col md="2" class="font-weight-black">Poznámka:</v-col>
            <v-col>{{ stanica.Poznamka }}</v-col>
          </v-row>
          <v-row dense>
            <v-col md="2" class="font-weight-black">X,Y,Z JTSK:</v-col>
            <v-col>
              <i>[{{ stanica.X }}, {{ stanica.Y }}, {{ stanica.Z }}]</i>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col md="2" class="font-weight-black">WGS 84:</v-col>
            <v-col>
              <i>{{ stanica.Lat }}, {{ stanica.Lng }}</i>
              <br />
              <a
                :href="
                  'http://boulter.com/gps/?c=' + stanica.Lat + '+' + stanica.Lng
                "
                target="_blank"
                >Zobraz na mape</a
              >
            </v-col>
          </v-row>
          <v-row dense>
            <v-col md="2" class="font-weight-black">Lokality:</v-col>
            <v-col>
              <v-breadcrumbs
                class="pa-0"
                divider="-"
                :items="stanicaLokality"
              ></v-breadcrumbs>
            </v-col>
          </v-row>
          <v-btn @click="editStanica()">Editovať</v-btn>
          <v-btn @click="addZrazky()">Pridať zrážky</v-btn>
        </v-container>
      </v-tab-item>
      <v-tab-item>
        <v-container class="mt-2 elevation-3" fluid>
          <l-map
            :zoom="zoom"
            :center="center"
            style="height: 600px; width: 100%; z-index: 0"
            ref="map"
            @ready="setMapView"
          >
            <l-control-scale
              position="topright"
              :imperial="false"
              :metric="true"
            ></l-control-scale>
            <l-control position="bottomright">
              <v-img :src="require('../assets/nautical.svg')"></v-img>
            </l-control>
            <l-control-layers position="topright"></l-control-layers>
            <l-tile-layer
              v-for="tileProvider in tileProviders"
              :key="tileProvider.name"
              :name="tileProvider.name"
              :visible="tileProvider.visible"
              :url="tileProvider.url"
              :attribution="tileProvider.attribution"
              layer-type="base"
            />

            <l-marker
              v-if="stanica.Lat != 0 && stanica.Lng != 0"
              :lat-lng="[stanica.Lat, stanica.Lng]"
            ></l-marker>
          </l-map>
        </v-container>
      </v-tab-item>
      <v-tab-item fluid>
        <v-data-table
          :headers="zrazkyHeaders"
          :items="zrazky"
          :items-per-page="10"
          sort-by="ID"
          class="elevation-1 clickableTable"
          :custom-sort="customSort"
          @click:row="showItem($event)"
        ></v-data-table>
        <div class="text-right">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <download-excel :data="zrazky" class="exportXLS">
                <v-icon v-on="on">mdi-microsoft-excel</v-icon>
              </download-excel>
            </template>
            <span>Export do xls</span>
          </v-tooltip>
        </div>
      </v-tab-item>
      <v-tab-item>
        <v-container class="mt-2 elevation-3" fluid>
          <v-row align="end">
            <v-col cols="4">
              <v-select
                :items="chartYears"
                label="Rok"
                hint="Vyplniť ak chcete zobraziť údaje za konkrétny rok, napr. 2020"
                v-model="filterRok"
              ></v-select>
            </v-col>
            <v-col cols="8">
              <v-range-slider
                label="Výber referenčného obdobia"
                v-model="filterRange"
                step="1"
                :min="filterMinYear"
                :max="filterMaxYear"
                ticks="always"
                tick-size="4"
                thumb-label="always"
              ></v-range-slider>
            </v-col>
          </v-row>
          <v-row>
            <stanica-chart
              typ="monitZaklKlimFaktory"
              :stanica="stanica"
              :filterRok="filterRok"
            ></stanica-chart>
          </v-row>
          <v-row>
            <stanica-chart
              typ="denneMaxima"
              :stanica="stanica"
              :filterRok="filterRok"
              :filterRokOd="filterRange[0]"
              :filterRokDo="filterRange[1]"
            ></stanica-chart>
          </v-row>
          <v-row>
            <stanica-chart
              typ="kumul30dni"
              :stanica="stanica"
              :filterRok="filterRok"
              :filterRokOd="filterRange[0]"
              :filterRokDo="filterRange[1]"
            ></stanica-chart>
          </v-row>
          <v-row>
            <stanica-chart
              typ="kumulDlhod1"
              :stanica="stanica"
              :filterRok="filterRok"
              :filterRokOd="filterRange[0]"
              :filterRokDo="filterRange[1]"
            ></stanica-chart>
          </v-row>
          <v-row>
            <stanica-chart
              typ="kumulDlhod2"
              :stanica="stanica"
              :filterRok="filterRok"
              :filterRokOd="filterRange[0]"
              :filterRokDo="filterRange[1]"
            ></stanica-chart>
          </v-row>
        </v-container>
      </v-tab-item>
    </v-tabs>
    <meranie-dialog
      typ="zrazky"
      :editable="true"
      ref="dialogMeranie"
      @change="readZrazky"
      @delete="readZrazky"
    />

    <stanica-detail
      ref="dialogStanica"
      @change="readStanica($route.params.lokalitaId, $route.params.id)"
      @delete="deleted()"
    ></stanica-detail>
  </v-container>
</template>

<script>
import MeranieDialog from "../components/MeranieDialog.vue"
import StanicaDetail from "../components/StanicaDetail.vue"
import {
  LMap,
  LTileLayer,
  LMarker,
  LControl,
  LControlLayers,
  LControlScale
} from "vue2-leaflet"
import * as Miscella from "../plugins/miscella.js"
// import * as moment from "moment"
import DownloadExcel from "vue-json-excel"
//import Vue from "vue"
import StanicaChart from "../components/charts/StanicaChart.vue"

export default {
  components: {
    DownloadExcel,
    LMap,
    LTileLayer,
    LMarker,
    MeranieDialog,
    StanicaDetail,
    StanicaChart,
    LControl,
    LControlLayers,
    LControlScale
  },

  data: () => ({
    tab: 0,
    customSort: Miscella.customSort,
    stanica: {
      Lokalita: {},
      LokalityIds: [],
      Lat: 0,
      Lng: 0
    },
    mapOptions: {
      zoomSnap: 0.5
    },
    zrazky: [],
    lokality: [],
    zrazkyHeaders: [
      { text: "ID", align: "left", sortable: true, value: "ID" },
      { text: "Dátum", align: "left", sortable: true, value: "DatumString" },
      { text: "Typ", align: "left", sortable: true, value: "Typ" },
      { text: "Zrážky", align: "right", sortable: true, value: "Zrazky" },
      {
        text: "Priemerná teplota",
        align: "right",
        sortable: true,
        value: "TeplotaP"
      },
      {
        text: "Max.teplota",
        align: "right",
        sortable: true,
        value: "TeplotaMax"
      },
      {
        text: "Min.teplota",
        align: "right",
        sortable: true,
        value: "TeplotaMin"
      },
      {
        text: "Mraz.dní",
        align: "right",
        sortable: true,
        value: "PocetM"
      },
      {
        text: "Poznámka",
        align: "left",
        sortable: true,
        value: "Poznamka"
      }
    ],
    zoom: 8,
    center: [48.6, 19.7],
    url: "http://{s}.tile.osm.org/{z}/{x}/{y}.png",
    filterRok: 0,
    chartYears: [],
    filterRange: [],
    tileProviders: [
      {
        name: "OpenTopoMap",
        visible: false,
        attribution:
          'Map data: &copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>, <a href="http://viewfinderpanoramas.org">SRTM</a> | Map style: &copy; <a href="https://opentopomap.org">OpenTopoMap</a> (<a href="https://creativecommons.org/licenses/by-sa/3.0/">CC-BY-SA</a>)',
        url: "https://{s}.tile.opentopomap.org/{z}/{x}/{y}.png"
      },
      {
        name: "FreeMapSk",
        visible: true,
        attribution:
          '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, vizualization CC-By-SA 2.0 <a href="http://freemap.sk">Freemap.sk</a>',
        url: "https://{s}.freemap.sk/T/{z}/{x}/{y}.jpeg"
      },
      {
        name: "ZBGIS",
        visible: true,
        attribution:
          '&copy; <a target="_blank" href="https://zbgis.skgeodesy.sk/">ZBGIS</a>',
        url:
          "https://zbgis.skgeodesy.sk/zbgis/rest/services/ZBGIS/MapServer/tile/{z}/{y}/{x}"
      },
      {
        name: "OpenStreetMap",
        visible: true,
        attribution:
          '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
        url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      }
    ]
  }),

  computed: {
    filterMinYear: function() {
      if (this.chartYears.length > 0) {
        return this.chartYears[0]
      }
      return null
    },
    filterMaxYear: function() {
      if (this.chartYears.length > 0) {
        return this.chartYears[this.chartYears.length - 1] + 1
      }
      return null
    },
    isLokalita: function() {
      let ret = false
      if (Miscella.isSet(this.stanica)) {
        if (Miscella.isSet(this.stanica.Lokalita)) {
          if (this.stanica.Lokalita.ID !== 0) {
            ret = true
          }
        }
      }
      return ret
    },
    breadcrumbsItems: function() {
      let ret = null
      if (this.isLokalita) {
        ret = [
          {
            to: {
              name: "lokalita",
              params: { id: this.stanica.Lokalita.ID }
            },
            text: "Lokalita " + this.stanica.Lokalita.Name
          },
          { text: "Stanica " + this.stanica.Stanica }
        ]
      }
      return ret
    },
    stanicaLokality: function() {
      console.log("stanicaLokality evaluating START")
      let arr = []
      if (Miscella.isSet(this.stanica)) {
        for (let i = 0; i < this.stanica.LokalityIds.length; i++) {
          let lokalitaID = this.stanica.LokalityIds[i]
          console.log(`stanicaLokality, lokalitaID=${lokalitaID}`)
          for (let j = 0; j < this.lokality.length; j++) {
            let lokalita = this.lokality[j]
            if (lokalita.ID === lokalitaID) {
              let item = {
                to: {
                  name: "lokalita",
                  params: { id: lokalita.ID }
                },
                text: lokalita.Name
              }
              arr.push(item)
            }
          }
        }
      }
      console.log("stanicaLokality evaluating END", arr)
      return arr
    }
  },

  methods: {
    editStanica: function() {
      this.$refs.dialogStanica.show(this.stanica)
    },

    readStanica: async function(lokalitaId, id) {
      console.log("STANICA, readStanica", lokalitaId, id)
      try {
        let response = await this.$axios.get(`/r/stanica/${lokalitaId}/${id}`)
        if (response.status === 200) {
          this.stanica = this.transformItem(response.data)
        } else {
          this.$store.commit("alert", response.data.Error)
        }
      } catch (error) {
        this.$store.commit("alert", error.toString())
      }
      console.log("STANICA, readStanica END")
    },
    readZrazky: async function() {
      let id = this.$route.params.id
      console.log("STANICA, readZrazky", id)
      try {
        let response = await this.$axios.get(`/r/zrazky/${id}`)
        if (response.status === 200) {
          this.zrazky = this.transformItems(response.data)
        } else {
          this.$store.commit("alert", response.data.Error)
        }
      } catch (error) {
        this.$store.commit("alert", error.toString())
      }
      console.log("STANICA, readZrazky END")
    },
    transformItem: function(item) {
      return item
    },
    transformItems: function(items) {
      items.forEach(item => {
        item.DatumString = Miscella.formatDatum(item.Datum)
        item.DatumDate = Miscella.getDate(item.Datum)
      })
      return items
    },
    setMapView: function() {
      this.$nextTick(() => {
        if (this.stanica.Lat != 0 && this.stanica.Lng != 0) {
          this.$refs.map.mapObject.setView(
            [this.stanica.Lat, this.stanica.Lng],
            12
          )
        }
      })
    },
    readLokality: async function() {
      try {
        let response = await this.$axios.get("/r/lokality")
        if (response.status === 200) {
          this.lokality = response.data
          console.log("readLokality END", this.lokality)
        } else {
          this.$store.commit("alert", response.data.Error)
        }
      } catch (error) {
        this.$store.commit("alert", error.toString())
      }
    },
    deleted: function() {
      if (this.isLokalita) {
        this.$router.push({
          name: "lokalita",
          params: { id: this.stanica.Lokalita.ID }
        })
      } else {
        this.$router.push({ name: "stanice" })
      }
    },
    readChartLimits: async function(id) {
      console.log("readChartLimits END", id)
      try {
        let response = await this.$axios.get(
          `/r/chart/shmu/limit?stanicaID=${id}`
        )
        if (response.status === 200) {
          this.filterRok = null
          this.chartYears = response.data.data
          if (this.chartYears.length > 0) {
            this.chartYears = this.chartYears.sort(function(a, b) {
              return a - b
            })
            this.filterRok = this.chartYears[this.chartYears.length - 1]
          }
          this.filterRange = [this.filterMinYear, this.filterMaxYear]
          console.log("readChartLimits END", this.chartYears)
        } else {
          this.$store.commit("alert", response.data.Error)
        }
      } catch (error) {
        this.$store.commit("alert", error.toString())
      }
    },
    showItem: function(item) {
      this.$refs.dialogMeranie.show(item)
    },
    addZrazky: function() {
      this.$nextTick(
        function() {
          this.$refs.dialogMeranie.show({ ID: 0, StanicaID: this.stanica.ID })
        }.bind(this)
      )
    }
  },

  mounted: async function() {
    console.log("stanica mounted")
    await this.$store.dispatch("fetchme", this.$axios)
    this.readStanica(this.$route.params.lokalitaId, this.$route.params.id)
    this.readZrazky()
    this.readLokality()
    this.readChartLimits(this.$route.params.id)
  }
}
</script>
